export var provideParentUuidPopperKey = Symbol();
